<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol >
                    <h1 class="page__title text-center">{{ $t(titlePage) }}</h1>
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields 
                            :fields="tables.importLogs.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="tables.importLogs.allFields"
                                        :activeFields.sync="tables.importLogs.fields"
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                     :addTableClasses="['table--sm']"
                                    :items="tables.importLogs.items"
                                    :fields="traslateArrayObjects({ 
                                        array:tables.importLogs.fields,
                                        fields:['label']
                                    })"
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="tables.importLogs.columnFilterValue"
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.importLogs.rows"
                                    v-bind="tables.importLogs"
                                >
                                    <template #id="{ index }" >
                                        <td>
                                            {{ index }}
                                        </td>
                                    </template>
                                    
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'/import_logs.api/list/'+importUuid"
                                                :table="tables.importLogs"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.importLogs.total_pages > 0"
                            >
                                
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.importLogs.page"
                                        :pages="tables.importLogs.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.importLogs.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import { cilPlus, cilSettings, cilPencil, cilTrash, cilArrowThickFromRight } from '@coreui/icons';
import { mapGetters } from "vuex";
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js';
import TableSettings from "£lement/TableSettings";
import ImportLogsTable from "./config/tables/import_logs.js";
export default {
    name:"ImportLogsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, tableMixin ],
    components:{
        FilterDate,
        FilterFields,
        ButtonExport,
        ButtonBack,
        TableSettings
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight
    },
    data(){
        return{
            tables:{
                importLogs:ImportLogsTable
            }
        }
    },
    computed:{
        ...mapGetters({
            from:"filter/from",
            to:"filter/to"
        }), 
        importUuid:function(){
            return this.$route.query.uuid;
        }
    },
    methods:{
        itemPerPage(newValue){
            this.tables.importLogs.rows = newValue;
            this.updatePagination(this.tables.importLogs.page);
        },
        updatePagination(newValue){
            this.tables.importLogs.page = newValue;
            this.updateData();
        },
        async updateData(){
            await this.updateTable({
                tableName:"importLogs", 
                url:`/import_logs.api/list/${this.importUuid}`,

            });
            this.tables.importLogs.loading = false;
            this.updatePageLoading(false);
        }
        
    },
    mounted(){
        this.updateData();
    }

}
</script>

<style scoped lang="scss">
    /* .request-report{
        overflow: hidden;
        width: 30%;
    }
    .message{
        width: 30%;
        overflow: hidden;
    } */
    .message__container{
        overflow: hidden;
    }

    .pre{
        & .pre__container{
            max-width: 30rem;
            overflow: auto;
            & .span__pre {
                display: block;
                unicode-bidi: embed;
                font-family: monospace;
                /* white-space: pre; */
                white-space: pre-wrap;
            }
        }
        
    }
    
    
</style>